<template>
  <div class="detailAbstract">
    <div class="abstractTitle">{{ title }}纪要</div>
    <div class="abstractContent">
      <div>内容描述：{{ content }}</div>
    </div>
    <div class="abstractImgs">
      <div>图片：</div>
      <div class="imgWrap">
        <el-image
          class="imgs"
          v-for="(img, i) in imglist"
          :key="i"
          :src="img"
          :preview-src-list="imglist"
          @load="load"
          @error="load"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: "暂无",
    },
    imglist: {
      type: Array,
    },
  },
  data() {
    return {
      imgNumber: 0,
    };
  },
  mounted() {
    console.log(this.imglist, "-------------");
  },
  methods: {
    load() {
      console.log("没有图片不会触发");
      // 等待所有图片加载完成
      this.imgNumber++;
      if (this.imgNumber == this.imglist.length) {
        this.imgNumber = 0;
        this.$emit("load");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detailAbstract {
  width: 100%;
  height: auto;
  margin-top: 32px;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 2px;
  background: RGBA(248, 250, 251, 1);
  font-size: 15px;
  color: #707b86;
  .abstractTitle {
    color: #394259;
    position: relative;
    padding-left: 4px;
    &::before {
      content: "";
      width: 2px;
      height: 14px;
      position: absolute;
      top: 4px;
      left: 0px;
      background: var(--themeColor);
    }
  }
}

.abstractContent {
  display: flex;
  margin: 24px 0;
  div {
    &:first-child {
      width: 400px;
    }
    &:nth-child(2) {
      color: #3b445a;
    }
  }
}

.abstractImgs {
  .imgWrap {
    display: flex;
    flex-direction: flex-start;
    flex-wrap: wrap;
    .imgs,
    .imgs img {
      margin: 12px 8px;
      width: 62px;
      height: 62px;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>